import esLogo from 'assets/rebrand/logos/eurostar.svg';
import nsLogo from 'assets/rebrand/logos/nsInternational.png';

export const brandIcons = {
  Eurostar: esLogo,
  'TGV INOUI': 'https://static.eurostar.com/ui/design-system/logos/inoui.svg',
  SNCB: 'https://static.eurostar.com/ui/design-system/logos/sncb.svg',
  Lyria: 'https://static.eurostar.com/ui/design-system/logos/lyria.png',
  DB: 'https://static.eurostar.com/myb/shared/DB.svg',
  ICE: 'https://static.eurostar.com/myb/shared/DB.svg',
  IC: 'https://static.eurostar.com/myb/shared/DB.svg',
  NS: nsLogo
};
